import {HTTP} from "../http";

import {chunkPeriod} from "./chunkDate";

export async function requestHandler (url, payload, reverse = false) {
    const periods = reverse ? chunkPeriod(payload.dateFrom, payload.dateTo).reverse() : chunkPeriod(payload.dateFrom, payload.dateTo)
    if(periods.length) {
        let array = []
        let delay = 0; const delayIncrement = 100;

        const promises = periods.map(p => {
            delay += delayIncrement;
            return new Promise(resolve => setTimeout(resolve, delay)).then(async () => {
                const {data} = await HTTP.post(url, {
                    ...payload,
                    dateFrom: p.dateFrom,
                    dateTo: p.dateTo
                })
                return data.data
            })

        })

        await Promise.all(promises) .then(res => {
            array = res.reduce((acc, val) => acc.concat(val), [])
        })
        // let promiseExecution = async () => {
        //     for (let period of periods) {
        //         try {
        //             const {data} = await HTTP.post(url, {
        //                 ...payload,
        //                 dateFrom: period.dateFrom,
        //                 dateTo: period.dateTo
        //             });
        //             array = [...array, ...data.data]
        //         } catch (error) {
        //             console.log(error.message);
        //         }
        //     }
        // }
        // await promiseExecution();

        return {
            status: true,
            errors: [],
            data: array
        }
    } else {
        return new Promise((resolve, reject) => {
            HTTP.post(url, payload)
                .then(res => {
                    resolve(res.data)
                }, (res) => {
                    reject(res)
                })
        })
    }
}